import { initSlider } from './js/slider.js';
import { initExperts } from './js/experts.js';
import { initTestimonials } from './js/testimonials.js';
import workerHandler from './js/workerHandler.js';
import { addSeoClassNames, SEO_BR_INFO_PAGE, loadingSupportChat, setTimezone } from '../_modules/helpers.js';
import { handleRefsBr } from "@studybay/common-client-library/ref-handle"
import initHeader from '../_modules/new_header/header';

if (document.readyState === 'interactive') {
    init();
} else {
    document.addEventListener('DOMContentLoaded', init, { once: true });
}

function init() {
    initHeader()
    workerHandler.init({onTerminate: () => {
        handleRefsBr(SEO_BR_INFO_PAGE)
        addSeoClassNames()
    }})
    initSlider('.team-slider');
    initExperts();
    initTestimonials();
    loadingSupportChat.init();
    setTimezone();
}
